import { render, staticRenderFns } from "./CalcResultado.vue?vue&type=template&id=02952b9c&scoped=true"
import script from "./CalcResultado.vue?vue&type=script&lang=js"
export * from "./CalcResultado.vue?vue&type=script&lang=js"
import style0 from "./CalcResultado.vue?vue&type=style&index=0&id=02952b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02952b9c",
  null
  
)

export default component.exports